import {
  useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  ShoppingCartOutlined,
  SendOutlined,
  EnvironmentOutlined,
  RadarChartOutlined,
  CheckCircleOutlined,
  AppstoreOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <SendOutlined />,
  1: <EnvironmentOutlined />,
  2: <RadarChartOutlined />,
  3: <CheckCircleOutlined />,
};

const HighlightsSection = () => {
  const { t } = useTranslation("tms");

  const items = useMemo(() => {
    const raw = t("highlights.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  const statFlow = useMemo(() => {
    const raw = t("highlights.stat_flow", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as string[];
  }, [t]);

  const statValue = t("highlights.stat_value");
  const statLabel = t("highlights.stat_label");
  const statDesc = t("highlights.stat_desc");

  return (
    <section className="dev-tms-section dev-tms-highlights-section">
      <div className="dev-tms-section-inner">
        <h2 className="dev-section-h2 dev-tms-section-h2">
          <span className="dev-tms-section-h2-icon dev-tms-section-h2-icon--cyan" aria-hidden>
            <AppstoreOutlined />
          </span>
          <span>{t("highlights.title")}</span>
        </h2>

        <div className="dev-tms-highlights-grid">
          <div className="dev-tms-highlight-list">
            {items.map((item, idx) => (
              <div key={idx} className="dev-tms-highlight-item">
                <div className="dev-tms-highlight-icon">
                  {iconByIndex[idx] ?? <ShoppingCartOutlined />}
                </div>
                <div>
                  <div className="dev-tms-highlight-title">{item.title}</div>
                  <div className="dev-tms-highlight-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="dev-tms-stat-card dev-tms-stat-card--savings">
            <div className="dev-tms-stat-value">{statValue}</div>
            <div className="dev-tms-stat-label">{statLabel}</div>
            <div className="dev-tms-stat-desc">{statDesc}</div>
            {statFlow.length > 0 && (
              <div className="dev-tms-stat-flow">
                {statFlow.map((step, idx) => (
                  <span key={step} className="dev-tms-stat-flow-item">
                    {idx > 0 && <ArrowRightOutlined className="dev-tms-stat-flow-arrow" />}
                    <span>{step}</span>
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
